import { COGNITO_ID } from "../constants";

export default {
  namespaced: true,
  state: {
    id_token: localStorage.getItem("id_token"),
    access_token: localStorage.getItem("access_token"),
    header: {},
    payload: {},
    signature: {},
    status_token: false
  },
  mutations: {
    saveToken(state, tokens) {
      if (
        tokens.length >= 2 &&
        tokens[0].split(".").length == 3 &&
        tokens[1].split(".").length == 3
      ) {
        state.id_token = tokens[0];
        localStorage.setItem("id_token", tokens[0]);
        state.access_token = tokens[1];
        localStorage.setItem("access_token", tokens[1]);
      }
    },
    loadToken(state) {
      state.id_token = localStorage.getItem("id_token");
      state.access_token = localStorage.getItem("access_token");
    },
    resetToken(state) {
      state.id_token = "";
      state.access_token = "";
      localStorage.setItem("id_token", "");
      localStorage.setItem("access_token", "");
      state.payload = {};
      state.status_token = false;
    },
    decodeToken(state) {
      if (state.id_token) {
        let atoken = state.id_token.split(".");
        if (atoken.length == 3) {
          //decode header
          let base64Url = atoken[0];
          let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
          state.header = JSON.parse(
            decodeURIComponent(
              atob(base64)
                .split("")
                .map(function(c) {
                  return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join("")
            )
          );

          //decode payload
          base64Url = atoken[1];
          base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
          state.payload = JSON.parse(
            decodeURIComponent(
              atob(base64)
                .split("")
                .map(function(c) {
                  return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join("")
            )
          );

          //signature is a hashed combination of header and payload
          state.signature = atoken[2];
        }
      }
    },
    validateToken(state) {
      let payload = state.payload;
      if (payload) {
        state.status_token =
          payload.aud == COGNITO_ID &&
          payload.exp > Math.floor(Date.now() / 1000);
      } else state.status_token = false;
    }
  },
  actions: {
    setToken({ commit }, tokens) {
      commit("saveToken", tokens);
      commit("decodeToken");
      commit("validateToken");
    },
    removeToken({ commit }) {
      commit("resetToken");
    },
    refreshToken({ commit }) {
      commit("loadToken");
      commit("decodeToken");
      commit("validateToken");
    }
  },
  getters: {
    getIdToken: state => () => {
      return state.id_token;
    },
    getAccessToken: state => () => {
      return state.access_token;
    },
    getPayload: state => () => {
      return state.payload;
    },
    getHeader: state => () => {
      return state.header;
    },
    getSignature: state => () => {
      return state.signature;
    },
    getAll: state => () => {
      return [state.header, state.payload, state.signature];
    },
    getStatusToken: state => {
      return state.status_token;
    }
  }
};
